<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_toc_2">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_toc_3">Dedication</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_toc_4">Author’s Note</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#a__Hlk132641631">Intro</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#a__eli50ujpekqp">Chapter One</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_toc_8">Chapter Two</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008#auto_bookmark_toc_10">Chapter Three</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0009#auto_bookmark_toc_11">Chapter Four</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0010#auto_bookmark_toc_13">Chapter Five</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0011#auto_bookmark_toc_14">Chapter Six</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0012#auto_bookmark_toc_16">Chapter Seven</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0013#auto_bookmark_toc_18">Chapter Eight</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0014#auto_bookmark_toc_19">Chapter Nine</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0015#auto_bookmark_toc_20">Chapter Ten</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0016#auto_bookmark_toc_22">Chapter Eleven</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0017#auto_bookmark_toc_23">Chapter Twelve</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0018#auto_bookmark_toc_25">Epilogue</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0019#auto_bookmark_toc_27">About the Author</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0020#auto_bookmark_toc_28">By TA Moore</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0021#auto_bookmark_toc_30">Keep Readihng - Wolf at First Sight</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0022#auto_bookmark_toc_33">Keep Reading - Monster Hall Pass</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0023#a__Hlk132724018">More from TA Moore</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0024#a__Hlk132725167">Visit Dreamspinner Press</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0025#auto_bookmark_toc_37">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?386ade8b